import { http } from '../lib/api/http';

const mapPlanRecord = record => {
  if (!record) return null;

  const theme = normalizeJson(record.theme || record.Theme);
  const features = normalizeJson(record.features || record.Features);

  const monthlyPrice =
    record.monthly_price ?? record.monthlyPrice ?? record.monthly ?? record.price_monthly;
  const yearlyPrice =
    record.yearly_price ?? record.yearlyPrice ?? record.yearly ?? record.price_yearly;

  return {
    id: record.slug || record.id,
    recordId: record.id,
    name: record.name || '',
    slug: (record.slug || record.id || '').toLowerCase(),
    order: Number(record.displayOrder ?? record.display_order ?? 0) || 0,
    monthlyPrice:
      monthlyPrice === null || monthlyPrice === undefined ? null : Number(monthlyPrice),
    yearlyPrice:
      yearlyPrice === null || yearlyPrice === undefined ? null : Number(yearlyPrice),
    publicationsLimit: Number(record.publicationsLimit ?? record.publications_limit) || 0,
    teamSeats: Number(record.teamSeats ?? record.team_seats) || 0,
    ppcCredits: Number(record.ppcCredits ?? record.ppc_credits) || 0,
    leadCredits: Number(record.leadCredits ?? record.lead_credits) || 0,
    allowsPriorityFeed: Boolean(record.allowsPriorityFeed ?? record.allows_priority_feed),
    verificationIncluded: Boolean(
      record.verificationIncluded ?? record.verification_included
    ),
    description: record.description || '',
    feedAccess: record.feedAccess || record.feed_access || '',
    feedInteractions: record.feedInteractions || record.feed_interactions || '',
    visibility: record.visibility || record.plan_visibility || '',
    features: Array.isArray(features)
      ? features.map(item => String(item))
      : String(features || '').split('\n').map(item => item.trim()).filter(Boolean),
    theme: theme && typeof theme === 'object' ? theme : {},
  };
};

function normalizeJson(value) {
  if (!value) return null;
  if (typeof value === 'object') return value;
  try {
    return JSON.parse(value);
  } catch {
    return null;
  }
}

export async function listMembershipPlans() {
  const response = await http.get('/membership-plans');
  const records = Array.isArray(response.data) ? response.data : [];
  return records.map(mapPlanRecord).filter(Boolean);
}

export async function getMembershipPlanBySlug(slug) {
  if (!slug) return null;
  const plans = await listMembershipPlans();
  const needle = String(slug || '').trim().toLowerCase();
  return plans.find(plan => plan.slug === needle) || null;
}
